var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2411 3.27824C15.587 2.44963 16.7609 2.44963 17.1068 3.27824L20.0741 10.3865C20.2123 10.7177 20.5158 10.9507 20.8714 10.9988L28.692 12.0573C29.5683 12.1759 29.8806 13.2831 29.1955 13.8422L23.1569 18.7699C22.8584 19.0135 22.7243 19.4057 22.8112 19.781L24.7418 28.1239C24.9508 29.0272 23.9351 29.7119 23.1762 29.1792L16.7547 24.6722C16.4061 24.4276 15.9417 24.4276 15.5932 24.6722L9.17157 29.1793C8.41269 29.7119 7.39698 29.0272 7.60599 28.124L9.53649 19.781C9.62335 19.4056 9.48928 19.0135 9.19077 18.7699L3.15231 13.8422C2.46717 13.2831 2.77953 12.1759 3.65585 12.0573L11.4765 10.9988C11.8321 10.9507 12.1355 10.7177 12.2737 10.3865L15.2411 3.27824Z",
    stroke: "#84BD86",
    strokeWidth: 4.04348,
    strokeMiterlimit: 3.3292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ffae8ef799a57ebee52c3d7a43cfaeda.svg";
export { ForwardRef as ReactComponent };